import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { Typography } from "@mui/material/";
import GridColumn from "../GridColumn";

export default ({ services, auditImageId }) => {
    const { typesList } = useSelector((state) => state);

    /** get ernest service id */
    const ernestService = useMemo(
        () =>
            typesList.services &&
            typesList.services.data.find((item) => item.name === "Ernest"),
        [typesList.services]
    );

    /** Change
     * 1.filter to find after backend update
     * 2. Check if the serviceValueResult is empty
     * */

    const ernest = useMemo(() => {
        return (
            services &&
            services.find(
                (item) =>
                    item.auditImageId === auditImageId &&
                    item.service === ernestService.id
            )
        );
    }, [services, auditImageId]);

    let ernestResult;

    if (ernest && ernest.result) {
        const res = ernest.serviceResultValue.split("from");
        ernestResult = `${parseFloat(res[0]).toFixed(2)} km from ${res[1]}`;
    } else if (ernest && !ernest.result)
        ernestResult = `${parseFloat(ernest.serviceResultValue).toFixed(
            2
        )} km `;


    return ernest && ernest.serviceResultValue.length > 0 ? (
        <GridColumn
            label="Ernest - Secondary Locations"
            value={
                <Typography
                    sx={{
                        color: ernest.result ? "green" : "red",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        whiteSpace: "nowrap"
                    }}
                    title={ernestResult}
                >
                    {ernestResult}
                </Typography>
            }
        ></GridColumn>
    ) : null;
};
